import React, { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';
// import { AdminContext } from '../../../context/AdminContext';
import styles from './styles.module.scss';

export default function Toggle({
  state,
  onClick,
  width = `w-[38px]`,
  height = `h-[18px]`,
  circleWidth = `w-[18px]`,
  circleHeight = `h-[18px]`,
  deactivePadding = `pr-[19px]`,
}) {
  const { themeColor } = useContext(AdminContext);
  return (
    // <div
    //   onClick={onClick}
    //   className={` unsetColors toggleColors ${
    //     !state && themeColor != 'white' && 'toggleColorsUnactive'
    //   } ${width} ${height} ${
    //     state
    //       ? `${styles.toggle_button_active} mainBg`
    //       : `${styles.toggle_button_deactive} ${deactivePadding}`
    //   }`}
    // >
    //   <div
    //     className={`${styles.toggle_circle_active} ${circleWidth} ${circleHeight}`}
    //   ></div>
    // </div>
    <input
      className={`${styles.switch} switch`}
      type={`checkbox`}
      checked={state}
      onClick={onClick}
    />
  );
}

{
  /* <label class={styles.switch} onClick={onClick}>
<input type='checkbox' />
<span class={`${styles.slider} ${styles.round}`}></span>
</label> */
}
